import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";

// Warm cream band so the scroll-to-inquiry CTA leads into the blush form
// instead of breaking the palette with the old purple block.
const ContactButtonWrapper = styled.div`
  margin: auto;
  padding: 30px auto;
  display: flex;
  justify-content: center;
  background-color: var(--jm-cream);
`;

// Sage-deep pill that matches the form's "Send inquiry" button.
const ContactBtn = styled(Button)`
  background-color: var(--jm-sage-deep) !important;
  color: #f4efe6 !important;
  margin: 50px auto !important;
  padding: 14px 48px !important;
  border-radius: 999px !important;
  font-family: var(--jm-sans) !important;
  font-weight: 600 !important;
  letter-spacing: 0.12em !important;
  text-transform: uppercase !important;
  &:hover {
    background-color: var(--jm-sage-hover) !important;
  }
  & span {
    text-transform: uppercase !important;
    color: #f4efe6 !important;
  }
`;

export const ContactButton = () => {
  return (
    <ContactButtonWrapper>
      <ContactBtn
        onClick={(e: any) => {
          const contactElem = document.getElementById("contact-section");
          const navbarElem = document.getElementById("navbar");
          if (!contactElem || !navbarElem) return;
          const contactElemBounds = contactElem.getBoundingClientRect();
          const navbarElemBounds = navbarElem.getBoundingClientRect();
          const scrollPosition =
            contactElemBounds.top + window.scrollY - navbarElemBounds.height;
          window.scroll(0, scrollPosition);
        }}
      >
        Contact Me
      </ContactBtn>
    </ContactButtonWrapper>
  );
};
